import './author.css'

const AuthorName = ({item}) => {
  return (
    <p className='author'>{item}</p>
  )
}

export default AuthorName